var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "px-0": "" } },
    [
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { xs12: "", md6: "", "pl-4": "", "pr-3": "", "pl-0": "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "", xs12: "", md12: "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmAddPlanTitle)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.showAttachPlan
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.bmAddFromPlan } },
                [
                  _c("v-select", {
                    staticClass: "ml-1",
                    attrs: {
                      items: _vm.dtPlans,
                      "item-value": "id",
                      "item-text": "name",
                      solo: ""
                    },
                    model: {
                      value: _vm.mediaPlan,
                      callback: function($$v) {
                        _vm.mediaPlan = $$v
                      },
                      expression: "mediaPlan"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showImportPlan
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.bmAddImportPlan } },
                [
                  _c("base-attachment-button", {
                    attrs: {
                      editMode: _vm.isUpdateAction,
                      multiple: "",
                      accept:
                        "video/*,image/*,.pdf,.doc,.docx,.xml.xlsx,.xls,.ppt, .pptx,.txt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    },
                    model: {
                      value: _vm.attachments,
                      callback: function($$v) {
                        _vm.attachments = $$v
                      },
                      expression: "attachments"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.hideAttachPlan
        ? _c(
            "v-flex",
            {
              staticClass: "form-section",
              attrs: { xs12: "", md6: "", "pl-4": "", "pr-3": "", "pl-0": "" }
            },
            [
              _c(
                "v-flex",
                { attrs: { "mb-3": "", xs12: "", md12: "" } },
                [
                  _c("v-layout", { staticClass: "title--text-custom" }, [
                    _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "primary--text" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmAddPlanOption)))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.hideAttachPlan
                ? _c(
                    "div",
                    [
                      _vm.blocks && _vm.blocks.length
                        ? [
                            _c("v-switch", {
                              staticClass: "share-file__switcher ml-1",
                              attrs: {
                                "hide-details": "",
                                color: "primary",
                                label: _vm.$t(
                                  _vm.lblSetting.document_form
                                    .shareWithBlockOwners
                                )
                              },
                              model: {
                                value: _vm.shareWithBlockOwners,
                                callback: function($$v) {
                                  _vm.shareWithBlockOwners = $$v
                                },
                                expression: "shareWithBlockOwners"
                              }
                            }),
                            _vm._v(" "),
                            _c("v-switch", {
                              staticClass: "share-file__switcher ml-1",
                              attrs: {
                                "hide-details":
                                  _vm.apartments && _vm.apartments.length > 0,
                                color: "primary",
                                label: _vm.$t(
                                  _vm.lblSetting.document_form
                                    .shareWithBlockTenants
                                )
                              },
                              model: {
                                value: _vm.shareWithBlockTenants,
                                callback: function($$v) {
                                  _vm.shareWithBlockTenants = $$v
                                },
                                expression: "shareWithBlockTenants"
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.apartments && _vm.apartments.length
                        ? [
                            _c("v-switch", {
                              staticClass: "share-file__switcher ml-1",
                              attrs: {
                                "hide-details": "",
                                color: "primary",
                                label: _vm.$t(
                                  _vm.lblSetting.document_form
                                    .shareWithApartmentOwners
                                )
                              },
                              model: {
                                value: _vm.shareWithApartmentOwners,
                                callback: function($$v) {
                                  _vm.shareWithApartmentOwners = $$v
                                },
                                expression: "shareWithApartmentOwners"
                              }
                            }),
                            _vm._v(" "),
                            _c("v-switch", {
                              staticClass: "share-file__switcher ml-1",
                              attrs: {
                                color: "primary",
                                label: _vm.$t(
                                  _vm.lblSetting.document_form
                                    .shareWithApartmentTenants
                                )
                              },
                              model: {
                                value: _vm.shareWithApartmentTenants,
                                callback: function($$v) {
                                  _vm.shareWithApartmentTenants = $$v
                                },
                                expression: "shareWithApartmentTenants"
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            label:
                              _vm.lblSetting.document_form.shareWithEntities
                          }
                        },
                        [
                          _c("base-autocomplete", {
                            attrs: {
                              items: _vm.coEntities,
                              multiple: true,
                              "return-object": false,
                              "item-value": "value",
                              "is-solo": ""
                            },
                            on: { SearchChange: _vm.handleGetEntities },
                            model: {
                              value: _vm.entities,
                              callback: function($$v) {
                                _vm.entities = $$v
                              },
                              expression: "entities"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("base-control-label-vertical", {
                        attrs: {
                          label: _vm.lblSetting.document_form.shareDescription
                        }
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5c0985a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5c0985a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-plan-modal-vertical/template.html
// module id = null
// module chunks = 